import { derived, writable } from "svelte/store";
import { userStore } from "../../../../src/svelte/api-stores/user-store";

export const content = writable("");

export const fontFamily = derived(userStore, ($userStore) =>
  $userStore.provider === "gcp" ? "Arial, sans-serif" : "Calibri, sans-serif",
);

export const fontSize = derived(
  userStore,
  ($userStore) =>
    $userStore.defaultFontSize ||
    ($userStore.provider === "gcp" ? "10pt" : "11pt"),
);
